import React, { useEffect, useState } from 'react';

import { useConfig } from '../../../ConfigContext';
import { ProviderLink } from '../provider/ProviderLink';
import logoEpic from '../../../_assets/epic.svg';
import { Popup } from '../../../utils/Popup';
import { del, post } from '../../../utils/Request';
import { useAuth } from '../../../authentication/AuthenticationContext';
import { RequestError } from '../../../Error.model';

export function Epic(): JSX.Element {
  const config = useConfig();
  const auth = useAuth();
  const [error, setError] = useState<RequestError | null>(null);

  const link = (): void => {
    const authUrl = `https://www.epicgames.com/id/authorize?client_id=${config.serverConfig.providers.epic.clientId}`
    + '&response_type=code&scope=basic_profile&prompt=login'
    + `&redirect_uri=${location.origin}/account/epic/redirect`;

    Popup.open(authUrl, 'epic_auth');
  };

  const unlink = (): void => {
    setError(null);
    del(`${config.clientConfig.host}/players/me/unlink/providers/epic`)
      .then(() => {
        auth.getPlayer();
      }).catch((err: RequestError) => {
        setError(err);
      });
  };

  const onLinkMessage = (event: MessageEvent): void => {
    setError(null);
    if (event.data.epicData) {
      post(`${config.clientConfig.host}/players/me/link`, {
        data: {
          type: 'epic',
          data: {
            idToken: event.data.epicData,
          },
        },
      })
        .then(() => {
          setError(null);
          auth.getPlayer();
        })
        .catch((err: RequestError) => {
          setError(err);
        });
    }
  };

  useEffect(() => {
    window.addEventListener('message', onLinkMessage);

    return () => {
      window.removeEventListener('message', onLinkMessage);
    };
  }, []);

  return (
    <ProviderLink
      providerName='epic'
      logo={logoEpic}
      link={link}
      unlink={unlink}
      error={error}
    />
  );
}
